import React from "react";
import { useTranslation } from "react-i18next";

import {
  Alert,
  Button,
  Divider,
  FormHelperText,
  Grid,
  Modal,
  Paper,
  Stack,
  Typography,
  Link
} from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { styled } from "@mui/material/styles";

const StyledBoxModal = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  height: "auto",
  bgcolor: "background.paper",
  border: "2px solid #fff",
  borderRadius: "15px",
  boxShadow: 24,
  padding: 14,
  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

const ApplyToFeaturedJobModal = ({
  job,
  open,
  onClose,
  incompleteTeacher,
  employerClickedApply,
  onApplyToJob,
}) => {
  const { t } = useTranslation();
  const stripedLink = job?.isLink
    ? job?.link?.split("//")[1]?.split("/")[0]
    : undefined;
  const disclaimerText = job?.isLink
    ? t("jobs.apply.disclaimerExternal", { domain: stripedLink })
    : t("jobs.apply.disclaimerOnce");
  return (
    <Modal open={open} onClose={onClose} disableScrollLock={true}>
      <StyledBoxModal>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{ padding: { xs: 0, md: 2 } }}
        >
          <Grid item xs={12} sm={9} md={6} sx={{ marginBottom: 5 }}>
            <Typography>
              {t("jobs.apply.confirmIntro", {
                company: job?.creator?.company,
                title: job?.title,
              })}
            </Typography>
            <Divider sx={{ width: "100%", margin: "0.5rem auto 0" }} />
            <Alert
              severity={
                incompleteTeacher || employerClickedApply ? "error" : "success"
              }
            >
              {incompleteTeacher && t("jobs.apply.incompleteProfile")}
              {employerClickedApply && t("jobs.apply.employersCannotApply")}
              {!incompleteTeacher &&
                !employerClickedApply &&
                t("jobs.apply.eligible")}
            </Alert>
          </Grid>
          <FormHelperText>
            {disclaimerText}
          </FormHelperText>
          <Divider
            variant="inset"
            flexItem
            sx={{ width: "100%", margin: "0.5rem auto" }}
          />



          <Grid
            item
            xs={12}
            sm={9}
            md={6}
            sx={{ display: "flex", flexDirection: "row", width: "100%" }}
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack
              spacing={2}
              direction="row"
              justifyContent="end"
              sx={{ width: "100%" }}
            >
              <Button
                size="small"
                onClick={onClose}
                color="error"
                variant="outlined"
              >
                {t("common.close")}
              </Button>
              {/* job.isLink ? open new tab with job.link : apply to job */}

              
              <Button
              endIcon={job?.isLink ? <OpenInNewIcon /> : undefined }
                size="small"
                onClick={job?.isLink ? () => window.open(job?.link, "_blank") : onApplyToJob}
                variant="contained"
                disabled={incompleteTeacher || employerClickedApply}
              >
                {job?.isLink ? t("common.viewJob") : t("common.apply")}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </StyledBoxModal>
    </Modal>
  );
};
export default ApplyToFeaturedJobModal;
